<template>
<div class="container-fluid">
    <app-loading :className="isLoading ? 'loading' : ''"></app-loading>
      <h3>Update App Information</h3>
      <hr/>
      <b-card>
        <b-form @submit="onSubmit">
          <!-- App Name -->
          <b-form-group
            id="input-group-1"
            label="App name:"
            label-for="input-1"
            description="Name for show in app store."
            >
          <b-form-input
            id="input-1"
            v-model="form.name"
            type="text"
            required
            placeholder="Enter app name"
          ></b-form-input>
          </b-form-group>

          <!-- Description -->
          <b-form-group
            label="Description:"
            label-for="input-4"
            >
          <b-form-textarea
            id="input-4"
            v-model="form.description"
            placeholder="Enter descirption..."
            rows="3"
            max-rows="4"
            required
          ></b-form-textarea>
          </b-form-group>
          <div class="save-card">
            <b-button @click="$router.go(-1)" class="mx-1" variant="outline-secondary">Back</b-button>
            <b-button class="btn-save-simple mx-1" variant="primary" type="submit">Save</b-button>
          </div>

        </b-form>
      </b-card>
  </div>
</template>

<script>
import Loading from '../../components/Loading';

export default {
  data () {
    return {
      appId: null,
      isLoading: false,
      form: {
        name: '',
        description: ''
      }
    };
  },
  methods: {
    onSubmit (e) {
      e.preventDefault();
      this.isLoading = true;
      this.axios.patch(process.env.VUE_APP_URL_UNIVERSAL_API + `/app-store/app/${this.appId}`, this.form)
        .then(response => {
          const data = response.data.data;
          const id = data.appStore[0].id;
          sessionStorage.setItem('app', JSON.stringify(data.appStore[0]));
          this.$router.replace({ name: 'apps2-details-2', params: { id } });
        })
        .catch(error => console.log(error))
        .finally(this.isLoading = false);
    },
    getAppInfo () {
      this.appId = this.$route.params.id;
      this.axios.get(process.env.VUE_APP_URL_UNIVERSAL_API + `/app-store/app/${this.appId}`)
        .then(response => {
          this.form = response.data.data.app;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(this.isLoading = false);
    }
  },
  created: function () {
    this.getAppInfo();
  },
  mounted () {
    document.title = 'Admin Console: Create App';
  },
  components: {
    'app-loading': Loading
  }
};
</script>
<style src="@/assets/css/appstore-landing2.css"></style>
